import script from "./UserLookupModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UserLookupModal.vue?vue&type=script&setup=true&lang=js"

import "./UserLookupModal.vue?vue&type=style&index=0&id=2797b56a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2797b56a"]])

export default __exports__